const header = {
    user: "Thông tin cá nhân",
    logout: "Đăng xuất",
    language: 'Ngôn ngữ',
    nameSystem: "Hệ thống VNS CamAI",
    notification: "Thông báo",
    checkAll: "Đánh dấu tất cả đã đọc",
    setupNotification: "Cài đặt thông báo",
    chanelNotification: "Kênh nhận thông báo",
    seeAll: "Xem tất cả thông báo",
    systemNotification: "Thông báo hệ thống",
    smartNoification: "Cảnh báo thông minh",
    emptyNotification: "Không có thông báo mới"
}

const infoUser = {
    header: "Tài khoản",
    info: "Thông tin cá nhân",
    changePassword: "Thay đổi mật khẩu",
    version: "Các phiên bản",
    userName: "Tên người dùng",
    lastEdit: "Sửa đổi lần cuối",
    phoneNumber: "Số điện thoại",
    company: "Công ty trực thuộc",
    email: "Email",
    groupUser: "Nhóm người dùng",
    timeCreate: "Thời gian tạo tài khoản",
    avatar: "Ảnh đại diện",
    upload_avatar: "Tải ảnh lên",
    change_image_success: "Thay đổi hình ảnh thành công!",
    change_image_error: "Thay đổi hình ảnh không thành công!",
    over_size_image: "Ảnh cần có dung lượng nhỏ hơn 10MB",
}

const changePassword = {
    currentPass: "Mật khẩu hiện tại",
    newPass: "Mật khẩu mới",
    confirmPass: "Nhập lại mật khẩu",
    title: "Dài trên 6 - 20 kí tự, bao gồm cả chữ, số, viết hoa, viết thường và cả những kí tự đặc biệt",
    emptyError: "Mật khẩu không được để trống",
    newPassEmtyError: "Mật khẩu mới không được để trống",
    newPassSameCurrentError: "Mật khẩu mới phải khác biệt với mật khẩu hiện tại",
    confirmPassEmtyError: "Mật nhập lại không được để trống",
    confirmPassNotSameError: "Mật khẩu nhập lại không giống",
    accept: "Xác nhận",
    canNotChangePass: "Không thể thay đổi mật khẩu",
    changePassSuccess: "Thay đổi mật khẩu thành công",
}

const version = {
    mobileVersion: "Phiên bản di động:",
    desktopVersion: "Phiên bản desktop:",
    downloadDesktopVersion: "Tải về desktop VNS CamAI"
}

const home = {
    notification: "Thông báo",
    cameraOnline: "Camera hoạt động",
}

const login = {
    login: "Đăng nhập",
    typeInfo: "Nhập thông tin tài khoản của bạn",
    companyCode: "Mã công ty",
    companyCodeEmptyError: "Mã công ty không được để trống",
    companyCodeType: "Mã số công ty chỉ chứa các ký tự viết hoa và số",
    userName: "Email hoặc tên đăng nhập",
    userNameEmptyError: "Tên tài khoản không được để trống",
    userNameType: "Tên người dùng dài từ 6 - 15 ký tự, chỉ chứa các ký tự viết thường và số.",
    typePass: "Nhập mật khẩu",
    passEmptyError: "Mật khẩu không được trống!",
    passType: "Mật khẩu dài 6-20 ký tự, phải chứa ký tự viết hoa, ký tự viết thường, ký tự đặc biệt, ký tự số, không chứa khoảng trắng",
    forgottenPass: "Quên mật khẩu?"
}

const sideBar = {
    home: "Trang chủ",
    dashboard: "Dashboard",
    live: "Xem trực tiếp",
    map: "Bản đồ",
    playback: "Xem lại",
    support: "Hỗ trợ",
    licensePlate: "Nhận dạng biển số",
    faceDetect: "Nhận dạng khuôn mặt",
    manage: "Quản trị",
    smartReport: "Cảnh báo thông minh",
    manager: "Quản lý chung",
    eventTracing: "Truy vết sự kiện",
    faceDetect: "Nhận dạng khuôn mặt",
    stream: "Xem trực tiếp",
    manageService: "Quản lý dịch vụ",
    manageDepartment: "Quản lý phòng ban",
    manageObject: "Quản lý đối tượng",
    findObject: "Tìm kiếm đối tượng",
    licensePlate: "Nhận dạng biển số xe",
    controlCam: "Đối soát camera",
    // manage: "Quản trị camera",
    cameraPermission: "Quyền camera",
    company: 'Công ty',
    wareHouse: 'Kho',
    cameraGroup: 'Nhóm camera',
    user: 'Người dùng',
    userPermission: 'Quyền người dùng',
    setDefault: 'Thiết lập mặc định',
    service: 'Dịch vụ',
    manageNotifi: "Quản trị thông báo",
    setNotifi: 'Cài đặt thông báo',
    manageChanelNotifi: 'Quản lý kênh thông báo',
    historyNotifi: 'Lịch sử thông báo',
    manageHistory: "Lịch sử",
    historyAccess: 'Lịch sử truy cập',
    historyUser: 'Lịch sử người dùng',
    historySetup: 'Lịch sử cấu hình',
    historyError: 'Lịch sử lỗi',
    smallMenu: "Thu nhỏ menu",
    ticketManagement: "Quản lý Ticket",
    aiAlert: "Cảnh báo AI",
}

const dashboard = {
    liveFeedTitle: "Giám sát an ninh AI Vision (Live Feed)",
    ticketDispatchTitle: "Bảng điều phối sự cố & Cập nhật Ticket",
    quickDispatch: "Điều phối nhanh",
    internalNote: "Ghi chú nội bộ",
    analystCamera: "Thống kê Camera",
    sumCam: "Tổng Camera",
    online: "Đang trực tuyến",
    ready: "Sẵn sàng",
    lostConnect: "Mất kết nối",
    analystAI: "Thống kê AI",
    motion: "Phát hiện chuyển động",
    object: "Phát hiện xâm nhập",
    move: "Camera dịch chuyển",
    sum: "Tổng",
    all: 'Không có camera',
    noPermission: "Bạn không có quyền xem thống kê",
    totalCamGroup: "Tổng số Camera theo nhóm",
    totalCamWarehouse: "Tổng số Camera theo kho",
    nodata: "Không có số liệu thống kê",
    face: "Nhận dạng khuôn mặt",
    fire: "Cảnh báo cháy",
    alpr: "Nhận dạng diển số xe",
    paking: "Bãi đỗ xe"
}

const stream = {
    customScreenError: "Vui lòng chọn hàng với cột tối thiểu 1",
    stream: "Xem trực tiếp",
    status: "Trạng thái",
    online: "Đang trực tuyến",
    lostConect: "Mất kết nối",
    ready: "Sẵn sàng",
    screenShow: "Màn hình hiển thị",
    other: "Khác",
    col: "Cột",
    row: "Hàng",
    acceptCustom: "Xác nhận",
    cancelCustom: "Hủy bỏ",
    minisizeScreen: "Thu nhỏ màn hình",
    fullScreen: "Toàn màn hình",
    reNameCam: "Đổi tên camera",
    nameCamera: "Tên camera",
    type: "Nhập",
    cancel: "Hủy",
    save: "Lưu lại",
    changePosotionSuccess: "Đổi vị trí camera thành công",
    changePosotionError: "Đổi vị trí camera chỉ áp dụng xem theo nhóm",
    restartCameraSuccess: "Khởi động lại thành công",
    restartCameraError: "Vui lòng thử lại sau vài phút",
    getListServiceError: "Lấy danh sách dịch vụ không thành công",
    brandNotSupportFireDetect: "Hãng camera không hỗ trợ cảnh báo cháy",
    turnOn: "Bật dịch vụ",
    success: "thành công",
    noPermissionTurnAI: "Bạn không có quyền bật/tắt AI",
    error: "không thành công",
    turnOff: "Tắt dịch vụ",
    infoCamera: "Thông tin camera",
    settingCamera: "Cài đặt camera",
    restart: "Khởi động lại",
    playback: "Xem lại",
    rename: "Đổi tên camera",
    renameCameraSuccess: "Chỉnh sửa thành công",
    renameCameraError: "Sửa tên camera không thành công",
    noCamera: "Không tìm thấy kết quả vui lòng chọn camera để xem",
    refresh: 'Làm mới'
}

const location = {
    getCityError: "Không thể tải xuống danh sách tỉnh/thành phố",
    getDistrictError: "Không thể tải xuống danh sách quận/huyện",
    getCommuneError: "Không thể tải xuống danh sách phường/xã",
    filter: "Bộ lọc",
    groupCam: "Nhóm camera",
    province: "Tỉnh",
    district: "Quận/Huyện",
    commune: "Phường/Xã",
    status: "Trạng thái",
    all: "Tất cả",
    record: "Bản ghi",
    isRecord: "Có bản ghi",
    noRecord: "Không có bản ghi",
    statusService: "Trạng thái dịch vụ",
    isOn: "Đang bật",
    isOff: "Đang tắt",
    accept: "Áp dụng",
    group: "Nhóm",
    address: "Địa điểm",
    cameraIsOff: "Camera đang tắt",
    changePositionWarehouseSuccess: "Đổi vị trí kho thành công",
    changePositionWarehouseError: "Đổi vị trí kho không thành công",
    find: "Tìm kiếm...",
    cameraIsLostConnect: "Camera đang mất kết nối",
    isOnline: "Đang trực tuyến",
    isOffline: "Đang tắt",
    isLostConnect: 'Mất kết nối',
    isWeek: "Kết nối yếu",
    seenCam: "Xem cam",
    noResult: "Không tìm thấy kết quả phù hợp",
    noResultAlt: "Không có nội dung tìm kiếm",
    updateSuccess: "Cập nhật thành công",
    updateError: "Không thể cập nhật",
}

const playback = {
    choseDay: "Chọn ngày",
    timeFrame: "Khung giờ",
    downLoad: "Tải Video",
    downLoading: 'Đang tải xuống',
    success: 'Thành công!',
    error: 'Tải thất bại!',
    getingVideo: 'Đang chuẩn bị video!',
    videoOverSize: "Không thể tải video quá 2h",
    noVideoInTime: 'không có video trong thời gian được chọn!',
    downloadError: "Tải xuống không thành công",
    emptyTime: 'Vui lòng chọn thời gian tải xuống',
    emptyCam: 'Vui lòng chọn ít nhất một cam',
    downloadVideo: "Tải xuống video",
    choseTimeError: "Vui lòng chọn ngày bắt đầu nhỏ hơn ngày kết thúc",
    start: "Từ",
    end: "Đến",
    cancel: " Hủy",
    down: " Tải xuống",
    isOnline: 'Đang trực tuyến',
    isReady: 'Sẵn sàng',
    isLostConnect: 'Mất kết nối',
    noPermissionViewCam: "Bạn không có quyển xem danh sách camera",
    isRecord: 'Có bản ghi',
    accept: "Áp dụng",
    screenView: "Màn hình hiển thị",
    minisize: "Thu nhỏ màn hình",
    fullsize: "Toàn màn hình",
    startDownload: "Bắt đầu tải xuống",
    errorDownloadVideo: "Có lỗi khi tải video",
    infoCamera: "Thông tin camera",
    settingCamera: "Cài đặt camera",
    downVideo: "Tải video",
    noCamera: "Không tìm thấy kết quả vui lòng chọn camera để xem lại",
    noPermissionViewInfoCam: "Bạn không có quyền xem thông tin của camera",
    playback: "Xem lại",
}

const infoCamera = {
    updateSuccess: "Cập nhập thành công",
    updateError: "Cập nhập không thành công",
    needRestart: "Camera bị mất kết nối cần được khởi động lại!",
    restartSuccess: "Khởi động lại thành công",
    restartAfterMinutes: "Vui lòng thử lại sau vài phút",
    type: "Nhập",
    cameraName: "Tên camera",
    brandName: "Hãng Camera",
    typeSetup: "Hình thức lắp đặt",
    warehouse: "Kho *",
    companyName: "Công ty trực thuộc",
    address: "Địa chỉ",
    resolution: "Độ phân giải nguồn chính",
    resolutionPlayback: "Độ phân giải video ghi lại",
    cameraIsOff: "Camera đang tắt",
    rtsp: "Đường dẫn rtsp *",
    rtpsEmpty: "Vui lòng nhập đúng đường dẫn rtsp",
    width: "Chiều rộng",
    height: "Chiều cao",
    subResolution: "Độ phân giải nguồn phụ",
    subResolutionEmty: 'Không có độ phân giải nguồn phụ',
    videoDecode: "Dạng mã hóa video *",
    accept: "Xác nhận",
    edit: "Chỉnh sửa",
    cancel: "Hủy bỏ",
    settingCamera: "Cài đặt Camera",
    restart: "Khởi động lại"
}

const settingCam = {
    Enable_recording_successfully: "Bật ghi lại thành công",
    Turn_off_recording_successfully: "Tắt ghi lại thành công",
    Successfully_turned_off_the_camera: "Tắt camera thành công",
    You_do_not_have_permission_to_turn_the_camera_on_or_off: "Bạn không có quyền bật tắt camera",
    Camera_turned_on_successfully: "Bật camera thành công",
    The_secondary_sources_cannot_be_the_same: "Các nguồn phụ không được giống nhau",
    You_do_not_have_permission_to_use_AI: "Bạn không có quyền sử dụng AI",
    The_system_is_processing_please_try_again_later: "Hệ thống đang xử lý vui lòng thử lại sau!",
    Record: "Ghi lại",
    Stream_mode: "Chế độ",
    Stream_protocol: "Giao thức",
    Desktop_resolution: 'Độ phân giải desktop',
    Recorded_storage_time_Days: "Thời gian lưu trữ ghi lại (Ngày)",
    Time_frame_allowed: "Khung giờ cho phép",
    Save_settings: "Lưu cài đặt",
    Camera_company_does_not_support_service: "Hãng camera không hỗ trợ dịch vụ",
    You_do_not_have_AI_administration_rights: "Bạn không có quyền quản trị AI",
    Unable_to_extract_recognition_areas: 'Không thể lấy ra các khu vực nhận diện',
    Retrieving_fire_alarm_configuration_failed: "Lấy cấu hình báo cháy không thành công",
    No_images: 'Không có hình ảnh',
}

const services = {
    licensePlate: "Nhận dạng biển số xe",
    cameraMoving: "Phát hiện camera di chuyển",
    fireWarning: "Cảnh báo cháy",
    faceRecognition: "Nhận dạng khuôn mặt",
    motionDetection: "Phát hiện chuyển động",
    detectCommonObjects: "Phát hiện xâm nhập",
    cameraRestartNotification: "Thông báo khởi động lại camera",
    notificationOfCameraLosingConnection: "Thông báo camera mất kết nối",
    notificationOfWarehouseConnectionLoss: "Thông báo kho mất kết nối",
    systemErrorMessage: "Thông báo lỗi hệ thống",
    eventTracing: "Truy vết sự kiện",
    Warehouse_lost_connection: "Kho mất kết nối",
    Camera_reboot: "Camera khởi động lại",
    Camera_lost_connection: "Camera mất kết nối",
    System_error: "Lỗi hệ thống",

}

const smartReport = {
    getInfoCamError: "Lấy thông tin camera không thành công",
    viewEvent: 'Xem lại sự kiện',
    config: 'Cấu hình',
    history: 'Lịch sử cảnh báo',
    setNotifi: 'Thiết lập cảnh báo ',
    statistic: 'Thống kê xuất báo cáo',
    viewFireMap: 'Xem bản đồ nhiệt',
    manager: 'Quản lý chung',

    find: "Tìm kiếm...",
    statusCam: 'Trạng thái camera',
    all: "Tất cả",
    statusAi: "Trạng thái AI",
    on: "Bật",
    off: 'Tắt',
    address: "Địa điểm",
    group: "Nhóm",
    service: "Dịch vụ",

    timeError: 'Thời gian chọn không phù hợp',
    timeEndGreatStart: 'Thời gian kết thúc không được nhỏ hơn thời gian bắt đầu',
    getListVideoError: "Lấy danh sách video không thành công",
    downVideoError: 'Có lỗi khi tải video',
    stt: 'STT',
    time: "Thời gian",
    object: "Đối tượng",
    action: "Hành động",
    noDataMatch: "Không có dữ liệu phù hợp",
    shoudChooseCam: "Vui lòng lựa chọn camera để xem video",
    inprogressBuild: "Chức năng đang phát triển!",

    cantGetListCamera: 'Không thể lấy danh sách camera',
    cantGetListVideo: 'Không thể tải danh sách video',
    restartSuccess: "Khởi động lại thành công",
    tryAffterSomeMinute: "Vui lòng thử lại sau vài phút",
    showInfo: "Xem thông tin",
    resolution: "Nguồn ưu tiên",
    noCamMatch: "Không có camera phù hợp",
    chart: "Biểu đồ",
    countEventChart: "Biểu đồ thống kê số lượng sự kiện",
    exportReport: "Xuất báo cáo",
    fileType: "Định dạng",
    choseCameraViewStatistic: "Vui lòng lựa chọn camera để  xem thống kê",
    licensePlate: "Biển số",
    licensePlateImage: "Hình ảnh biển số",
    noRecordInTime: "Không có bản ghi trong thời gian được chọn",
    cantGetNotifi: "Không thể tải thông báo",
    content: "Nội dung",
    reciver: "Người nhận",
    choseCameraViewNotifi: "Vui lòng lựa chọn camera để xem thông báo",
    day: "Ngày",
    timeStart: "Giờ bắt đầu",
    timeEnd: "Giờ kết thúc",
    choseCameraConfig: "Vui lòng lựa chọn camera để cấu hình"
}

const faceDetect = {
    deleteDepartment: "Xóa phòng ban thành công",
    deleteDepartmentError: "Xóa phòng ban không thành công",
    getListDepartment: "Lấy danh sách phòng ban không thành công",
    department: "Quản lý phòng ban",
    alertDeleteDepartment: "Xóa phòng ban sẽ xoá cả các đối tượng trong phòng ban!",
    nameDepart: "Tên phòng ban",
    company: "Đơn vị",
    countObject: "Số đối tượng",
    object: 'Danh sách đối tượng',
    getListObjectError: "Lấy danh sách đối tượng không thành công",
    alerRemoveObject: "Bạn có muốn xóa đối tượng ra khỏi phòng ban này",
    image: "Hình ảnh",
    nameEmploy: "Tên nhân viên",
    depart: "Phòng ban",
    timeAdd: 'Thời gian thêm vào hệ thống',
    removeCamera: "Xóa cam khỏi phòng ban thành công",
    removeCameraError: "Xóa cam khỏi phòng ban không thành công",
    addCamera: 'Thêm camera thành công',
    addCameraError: 'Thêm camera không thành công',
    getListCameraError: "Lấy danh sách camera không thành công",
    addCameraToDepart: "Thêm camera vào phòng ban",
    addCamera: 'Thêm camera',
    alertRemoveCamera: "Bạn có muốn xóa camera ra khỏi phòng ban này",
    addDepartment: "Thêm mới phòng ban thành công",
    addDepartmentError: "Thêm phòng ban không thành công",
    validateDepart: "Tên phòng ban, đơn vị không được để trống",
    editDepart: 'Sửa phòng ban thành công',
    editDepartError: 'Sửa phòng ban không thành công',
    editInfo: "Sửa thông tin",
    addNew: "Thêm mới",
    addNewDepart: "Thêm mới phòng ban",
    findObjectError: "Tìm kiếm đối tượng không thành công",
    findObject: "Tìm kiếm đối tượng",
    nameObject: "Tên đối tượng",
    getHistoryError: "Lấy danh sách lịch sử không thành công",
    historyObject: `Lịch sử nhận dạng của đối tượng`,
    timeDetect: "Thời gian nhận dạng",
    countValidate: 'Số lượng không được là số âm',
    findObjectValidate: "Điền đầy đủ thông tin để tìm kiếm",
    typeError: "không phải định dạng hợp lệ",
    imageObject: "Ảnh đối tượng",
    uploadImage: "Upload ảnh",
    maxObject: "Số đối tượng trả về tối đa",
    count: 'Nhập số lượng',
    find: "Tìm kiếm",
    getInfoError: "Lấy thông tin không thành công",
    choseCamera: 'Chọn camera để xem sự kiện nhận dạng khuôn mặt',
    employName: "Tên nhân viên",
    noResource: "Không rõ",
    start: "Bắt đầu",
    end: 'Kết thúc',
    choseCameraConfig: "Chọn camera để cấu hình nhận dạng khuôn mặt",
    variable: 'Thông số xử lý',
    roiList: "Khu vực giám sát",
    fileLock: "Danh sách khóa",
    getListobjectError: "Lấy danh sách đối tượng không thành công",
    deleteObject: "Xóa đối tượng thành công",
    deleteObjectError: "Xóa đối tượng không thành công",
    alertDelete: "Bạn có muốn xóa đối tượng này không",
    addObject: "Thêm mới đối tượng thành công",
    addObjectError: "Thêm mới đối tượng không thành công",
    validateAddObject: "Phòng ban, tên nhân viên và ảnh không được để trống",
    getInfoObjectError: "Lấy thông tin của đối tượng không thành công",
    editObject: "Sửa đối tượng thành công",
    editOnjectError: "Sửa đối tượng không thành công",
    objectNew: "Đối tượng lạ",
    detailInfo: "Thông tin chi tiết",

    Remove_object_from_list_successfully: "Xoá đối tượng khỏi danh sách thành công",
    Removing_object_from_list_failed: "Xoá đối tượng khỏi danh sách không thành công",
    Get_list_of_objects_failed: "Lấy danh sách đối tượng không thành công",
    Do_you_want_to_delete_this_object: "Bạn có muốn xóa đối tượng này không",
    Object_added_to_lock_list_successfully: "Thêm đối tượng vào danh sách khóa thành công",
    Adding_object_to_lock_list_failed: "Thêm đối tượng vào danh sách khóa không thành công",
    Get_list_failed: "Lấy danh sách không thành công",



}
const lisencePlate = {
    cantChoseLessTwo: "Không được chọn nhiều hơn hai camera",
    toastTurnOnLisencePlate: "Vui lòng bật dịch vụ nhận diện biển số để lựa chọn camera",
}
const cameraControl = {
    cameraControl: "Đối soát camera",
    reconciliation: "Đối soát",
    reconcileTotal: "Đối soát tổng",
    priceList: "Bảng giá",
    taxRate: "Mức thuế",
    camHistory: "Lịch sử sử dụng camera",
    FTTH_cost: "Chi phí FTTH",
    Labor_Contract_Expenses: "Chi phí LĐ/TD",
    New_installation_cost: "Chi phí lắp mới",
    Increased_cost_of_Cam_new_installation: "Chi phí tăng thêm Cam (lắp mới)",
    Connection_cost: "Chi phí đấu nối",
    Increased_cost_of_cams_connection: "Chi phí tăng thêm cam (đấu nối)",
    Total_cost_of_services_in_the_month: "Tổng cộng chi phí các dịch vụ trong tháng",
    VAT_Tax: "Thuế VAT",
    Total_after_tax: "Tổng cộng sau thuế",
    No_control_data_available: "Không có dữ liệu đối soát",
    Select_all_information: "Chọn đầy đủ thông tin có dấu * để tải báo cáo đối soát",
    Retrieving_information_failed: "Lấy thông tin không thành công!",
    Tax: "Thuế",
    Choose_a_company: "Chọn công ty",
    Select_invoice_detail_type: "Chọn loại chi tiết hóa đơn",
    Select_year: "Chọn năm",
    Year: "Năm",
    Select_month: "Chọn tháng",
    Month: "Tháng",
    View_information: "Xem thông tin",
    Export_report: "Xuất báo cáo",
    Applicable_information: "Thông tin áp dụng",
    Price_list_name: "Tên bảng giá",
    Tax_code: "Mã thuế",
    Day_start: "Từ ngày",
    Day_end: "Đến ngày",
    Cost: "Chi phí",
    There_is_no_cost_information: "Không có thông tin chi phí trong thời gian được chọn",
    Select_information_to_view_costs: "Chọn thông tin để xem chi phí",
    Control_details: "Chi tiết đối soát",
    No_data_available: "Không có dữ liệu!",
    Inventories_decreased_during_the_period: 'Các kho giảm trong kỳ',
    Accumulated_stocks_during_the_period: "Các kho lũy kế trong kỳ",
    Inventories_increased_during_the_period: 'Các kho tăng trong kỳ',
    Add_new_tax_rate: "Thêm mới mức thuế",
    Name: "Tên",
    Description: "Mô tả",
    Update: "Cập nhập",
    Add_new: "Thêm mới",
    Cancel: "Hủy bỏ",
    Name_of_the_repository_using_the_service: "Tên kho SDDV",
    Address: "Địa chỉ",
    Total_warehouse: "Tổng kho",
    Total_Camera: "Tổng Cam",
    New_installation_service: "Dịch vụ lắp mới",
    Connection_service: "Dịch vụ đấu nối",
    Total_number_of_FTTH_lines: "Tổng số đường FTTH",
    New_installation: "Lắp mới",
    Increase_more: "Tăng thêm",
    Total_at_the_end_of_the_period: "Tổng cộng cuối kỳ (Kho lũy kế + Kho tăng trong kỳ)",
    Downloading_data_failed: "Tải dữ liệu không thành công",
    The_feature_is_currently_in_development: "Tính năng hiện đang phát triển",
    Select_complete_information: "Chọn đầy đủ thông tin có dấu * để xem tổng chi phí!",
    Select_the_number_of_months: "Chọn số tháng",
    Select_the_starting_month: "Chọn tháng bắt đầu",
    Total_cost: "Chi phí tổng",
    Select_a_time_to_see_the_total_cost: "Chọn thời gian để xem chi phí tổng!",
    Details_of_periods: "Chi tiết các kỳ",
    No_data_available_for_the_selected_period: "Không có dữ liệu trong thời gian được chọn!",
    Select_a_period_to_view_period_details: "Chọn thời gian để xem chi tiết các kỳ!",
    TOTAL_COSTS_FOR_THE_PERIOD: "TỔNG CỘNG CHI PHÍ TRONG KỲ",
    VAT: "THUẾ VAT",
    TOTAL_AFTER_TAXES: "TỔNG CỘNG SAU THUẾ",
    status: "Tình trạng",
    The_start_time_must_be_less_than_the_end_time: 'Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc',
    Cannot_enter_more_than_155_characters: "Không thể nhập quá 155 ký tự",
    Tax_rate: "mức thuế",
    Tax_percentage: "Phần trăm thuế",
    Time_applies_from: "TG áp dụng từ",
    Successfully_removed_tax_rate: "Xóa mức thuế thành công",
    Delete_tax_rate_failed: "Xóa mức thuế không thành công",
    Added_successfully: "Thêm mới thành công",
    New_add_failed: "Thêm mới không thành công",
    The_price_list_cannot_be_edited_while_it_is_in_use: "Không thể chỉnh sửa bảng giá khi đang sử dụng",
    Cannot_remove_tariff_while_in_use: "Không thể xóa mức thuế khi đang sử dụng",
    Do_you_want_to_delete: "Bạn có muốn xóa không?",
    Tax_percentage_limit_from_0_to_100: 'Giới hạn phần trăm thuế từ 0% đến 100%',
    Tax_code_cannot_be_a_negative_number: "Mã số thuế không được là số âm",
    Edit: 'Chỉnh sửa',
    Camera_price: `Giá camera`,
    Camera_prices_increased: "Giá camera tăng thêm",
    FTTH_price: "Giá FTTH",
    Usage_time: `Thời gian sử dụng`,
    Warehouse_type: "Loại kho",
    default: "Mặc định",
    Connection: "Đấu nối",
    In_use: "Đang sử dụng",
    Not_yet_used: "Chưa sử dụng",
    Deleted_successfully: "Xóa thành công",
    Deleting_the_invoice_type_failed: "Xóa loại hóa đơn không thành công",
    Add_invoice_type: "Thêm loại hóa đơn",
    Inner_city_price: `Giá nội thành`,
    Out_of_town_price: "Giá ngoại thành",
    New_installation_price_increased: "Giá lắp mới tăng thêm",
    Installation_dismantling_costs: "Chi phí lắp đặt/tháo dỡ"
}
const cameraManager = {
    cameraManager: "Quản trị camera",
    statusActive: "Trạng thái kích hoạt",
    addNewCam: "Thêm mới camera",
    active: 'Kích hoạt',
    deleted: "Đã xóa",
    delete: "Xóa",
    restore: "Khôi phục camera",
    You_do_not_have_permission_to_get_the_camera_list: "Bạn không có quyền lấy danh sách camera",
    Error_from_server_side: "Lỗi từ phía server",
    You_do_not_have_camera_administrator_rights: "Bạn không có quyền quản trị camera",
    You_do_not_have_permission_to_obtain_camera_information: "Bạn không có quyền lấy thông tin camera",
    Deleted_camera_successfully: "Xóa camera thành công",
    You_do_not_have_permission_to_delete_the_camera: "Bạn không có quyền xóa camera",
    You_do_not_have_permission_to_edit_the_camera: "Bạn không có quyền chỉnh sửa camera",
    You_have_no_rights: "Bạn không có quyền",
    The_camera_lost_connection_and_needs_to_be_restarted: "Camera bị mất kết nối cần được khởi động lại!",
    The_operation_is_too_fast_Wait_a_few_minutes_to_continue_performing_the_operation: "Thao tác quá nhanh. Chờ sau  ít phút để tiếp tục thực hiện thao tác",
    Update_record_successfully: "Cập nhập ghi lại thành công"
}
const history = {
    Device: 'Thiết bị',
    Access_history: "Lịch sử truy cập",
    Configuration_type: 'Loại cấu hình',
    Configuration_history: "Lịch sử cấu hình",
    User_history: "Lịch sử người dùng",
    Error_code: 'Mã lỗi',
    Error_history: "Lịch sử lỗi"
}

const setting = {
    Please_turn_off_the_camera_to_edit_information: "Vui lòng tắt camera để sửa thông tin",
    Please_enable_live_streaming: "Vui lòng bật phát trực tiếp",
    Getting_list_of_subsource_resolutions_failed: "Lấy danh sách độ phân giải nguồn phụ không thành công!",
    Get_configuration_failed: "Lấy cấu hình thất bại",
    Number_of_days_retained_is_greater_than_default_number_of_days: "Số ngày lưu lại lớn hơn số ngày mặc định",
    Turning_off_the_service_will_delete_all_AI_videos_of_this_camera: "Tắt dịch vụ sẽ xóa hết các video AI của camera này!",
    Confirm_reset_to_default: "Xác nhận cài lại mặc định",
    Processing_parameters: "Thông số xử lý",
    Surveillance_area: "Khu vực giám sát",
    Unsupervised_area: 'Khu vực không giám sát',
    Select_object: 'Chọn đối tượng',
    You_do_not_have_permission_to_configure_AI: "Bạn không có quyền cấu hình AI",
    Setting: "Cài đặt",
    Start_time_must_be_less_than_end_date: "Giờ bắt đầu phải nhỏ hơn ngày kết thúc",
    Red_alert_time_is_greater_than: "Thời gian báo đỏ lớn 0",
    Delete_records_when_service_is_turned_off: "Xóa bản ghi khi tắt dịch vụ",
    Zoom_in_on_screen_when_warning_is_detected: "Phóng to màn hình khi phát hiện cảnh báo",
    Turn_on_sound: "Bật âm thanh",
    AI_Storage_Time: "Thời gian lưu trữ AI (Ngày)",
    Reset_to_default: "Cài lại mặc định",
    Configure_the_area_without: "Cấu hình khu vực không",
    Regional_configuration: "Cấu hình khu vực",
    Refresh_image: "Làm mới hình ảnh",
    Drawing: "Vẽ hình",
    Remove_background: "Bỏ nền",
    View_Partial: "Xem một phần",
    View_all: 'Xem tất cả',
    Watchlist: 'Danh sách theo dõi',
}

const param = {
    Lighting_conditions: "Điều kiện sáng",
    Sensitivity: "Độ nhạy",
    Object_size: "Kích thước đối tượng",
    Time_without_events: "Thời gian không có sự kiện",
    Minimum_event_time: "Thời gian sự kiện tối thiểu",
    Means_of_transport: "Phương tiện di chuyển",
    Accuracy_required: "Yêu cầu độ chính xác",
    Frame_skipping_level: "Mức độ bỏ qua khung hình",
    Face_detection_sensitivity: "Độ nhạy cảm phát hiện khuôn mặt",
    Face_matching_threshold: "Ngưỡng đối sánh khuôn mặt",
    Left_and_right_tilt: "Độ nghiêng trái phải",
    Head_tilt: 'Độ cúi, ngửa đầu',
    Face_Re_verification_Time: "Thời gian xác nhận lại khuôn mặt",
    Object_lifetime: "Thời gian sống của đối tượng",
    High: "Cao",
    Low: "Thấp",
    Medium: "Trung bình",
    Big: "Lớn",
    Small: "Nhỏ",
    Bottom_up: "Từ dưới lên",
    Top_to_bottom: "Từ trên xuống",
    Information: "Thông tin",
    Serious: "Nghiêm trọng",
    Alarm_temperature: "Nhiêt độ báo động",
    Do_not_miss_out: "Không bỏ qua",
    Highest: "Cao nhất"
}

const setupNotification = {
    Unread: "Chưa đọc",
    Read: "Đã đọc",
    Notification_Type: 'Loại thông báo',
    Select_camera_to_view_settings_information: "Chọn camera để xem thông tin cài đặt",
    System_warning: "Cảnh báo hệ thống",
    Real_time: "Thời gian thực",
    minute: "phút",
    Notification_name: 'Tên thông báo',
    Warning_color: 'Màu cảnh báo',
    Warning_level: 'Mức độ cảnh báo',
    Notification_time: 'Thời gian thông báo',
    Apply_all: "Áp dụng tất cả",
    Apply_new: "Áp dụng mới",
    Company_name: "Tên công ty",
    Sound: "Âm thanh",
    Notification_channel_management: "Quản lý kênh thông báo",
    Account_Name: "Tên tài khoản",
    Notification_channel: "Kênh thông báo",
    Display_name: "Tên hiển thị",
    Unit_name: 'Tên đơn vị',
}
const ticketManagement = {
    title: "Quản lý sự cố và ticket",
    createTicket: "Tạo Ticket Mới",
    updateTicket: "Cập nhật Ticket Xử Lý Sự Cố",
    ticketList: "Bảng điều phối sự cố & Cập nhật Ticket",
    ticketId: "Mã Ticket",
    residentInfo: "Thông tin cư dân/vị trí",
    incidentContent: "Nội dung sự cố",
    incidentType: "Loại sự cố",
    severity: "Mức độ",
    status: "Trạng thái xử lý",
    action: "Hành động",
    update: "Cập nhật",
    viewDetail: "Xem chi tiết",
    all: "Tất cả",
    pending: "Chưa xử lý",
    inProgress: "Đang xử lý",
    resolved: "Đã xử lý",
    critical: "Khẩn cấp",
    normal: "Thông thường",
    low: "Thấp",
    search: "Tìm kiếm ticket...",
    todayStats: "THỐNG KÊ HÔM NAY",
    totalIncidents: "Tổng số sự cố",
    totalTypes: "Tổng số loại sự cố",
    byStatus: "Sự cố theo Trạng thái xử lý",
    bySeverity: "Sự cố theo mức độ",
    residentAndLocation: "Thông tin Cư dân & Vị trí",
    selectApartment: "Chọn Căn hộ",
    residentName: "Tên cư dân",
    phoneNumber: "Số điện thoại",
    publicArea: "Báo cáo từ khu vực công cộng",
    specificLocation: "Vị trí cụ thể",
    feedbackDetail: "Chi tiết Phản hồi",
    selectIncidentType: "Chọn Loại sự cố",
    subject: "Chủ đề",
    detailedDescription: "Mô tả chi tiết",
    descriptionHint: "Mô tả cụ thể giúp xử lý nhanh hơn.",
    evidenceAndTime: "Bằng chứng & Thời gian",
    uploadAttachment: "Tải ảnh/video đính kèm",
    upload: "Upload",
    incidentStartTime: "Thời gian sự cố bắt đầu",
    residentAvailableTime: "Thời gian cư dân có nhà",
    responsibleDepartment: "Người xử lý",
    assignee: "Người xử lý",
    technical: "Kỹ thuật",
    cleaning: "Vệ sinh",
    security: "Bảo vệ",
    accounting: "Kế toán",
    internalNote: "Ghi chú nội bộ",
    optional: "Optional",
    saveDraft: "Lưu nháp",
    submit: "Gửi báo cáo",
    cancel: "Hủy",
    preview: "Xem trước",
    reset: "Làm mới",
    saveChanges: "Lưu thay đổi",
    sendReport: "Gửi báo cáo",
    closeTicket: "Đóng ticket",
    ticketInfo: "Thông tin Ticket",
    residentInfoSection: "Thông tin Cư dân",
    incidentDetail: "Chi tiết Sự cố",
    updateHistory: "Lịch sử Cập nhật",
    newUpdate: "Nhật ký Cập nhật mới",
    newUpdatePlaceholder: "Nhập nội dung cập nhật mới...",
    updateHint: "Cập nhật cụ thể giúp xử lý nhanh hơn.",
    processingSteps: "Quy Trình Xử Lý (5 Bước)",
    step1: "1. Tiếp nhận",
    step2: "2. Phân loại",
    step3: "3. Lên phương án",
    step4: "4. Khắc phục",
    step5: "5. Đóng ticket",
    quickDispatch: "Điều Phối nhanh",
    nextStep: "Chuyển sang bước tiếp theo",
    notifyResident: "Thông báo Cư dân",
    sendProgressNotification: "Gửi thông báo tiến độ cho cư dân",
    processingStats: "Thống kê xử lý",
    estimatedTime: "Thời gian dự kiến",
    estimatedCost: "Chi phí ước tính",
    fixDetail: "Chi tiết Khắc phục",
    fixStartTime: "Thời gian bắt đầu khắc phục",
    fieldMediaUpload: "Tải ảnh/video hiện trường",
    securityCamera: "An ninh (Camera)",
    technicalWater: "Kỹ thuật (Nước)",
    technicalElevator: "Kỹ thuật (Thang máy)",
    technicalElectric: "Kỹ thuật (Điện)",
    createSuccess: "Tạo ticket thành công!",
    updateSuccess: "Cập nhật ticket thành công!",
    draftSuccess: "Lưu nháp thành công!",
    confirmClose: "Bạn có chắc chắn muốn đóng ticket này?",
}
export const vi = {
    header, infoUser,
    changePassword,
    version,
    home,
    login,
    sideBar,
    dashboard,
    stream,
    location, playback, infoCamera, services, smartReport, faceDetect, lisencePlate, cameraManager,
    cameraControl,
    history,
    settingCam,
    setting,
    param,
    setupNotification,
    ticketManagement
}